import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import SimpleDate from 'app/common/classes/simple-date'

import styles from './CellExpiration.module.scss'

type Props = {
  expiredMessage: boolean
  expiredUntillMessage: boolean
  expiresAt: SimpleDate | null
}

const CellExpiration = ({ expiredMessage, expiredUntillMessage, expiresAt }: Props) => {
  const { t } = useTranslation('cafeteria')

  if (expiredUntillMessage && expiresAt && expiresAt.getIsValid()) {
    const until = expiresAt.isToday()
      ? expiresAt.getString('HH:mm')
      : expiresAt.getString('DD.MM.YYYY HH:mm')

    return <span className={styles.root}>{t('order_requests_edit_enabled_until', { until })}</span>
  }

  if (expiredMessage) {
    return (
      <span className={cn(styles.root, styles.disabled)}>
        {t('order_requests_edit_disabled', 'Редактирование\u000Aневозможно')}
      </span>
    )
  }

  return null
}

export default CellExpiration
